<style>
.table-border_ {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}
.table_w {
  font-family: arial, sans-serif;
  width: 100%;
}

.table-border_ td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.table-border_ tr:nth-child(even) {
  background-color: #dddddd;
}
.table_w_ {
  width: 45%;
  font-family: arial, sans-serif;
  float: right;
}
.block_right {
  text-align: end !important;
}
</style>

<template>
  <div class="content-wrapper" v-if="invoice.id">
     <!-- pdf-orientation="landscape" -->
    <VueHtml2pdf
      :show-layout="false"
      :float-layout="false"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      filename="myPDF"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-content-width="100%"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div class="row">
          <div class="col-12">
            <table class="table_w" cellpadding="0" cellspacing="0">
              <thead>
                <tr>
                  <th
                    style="
                      width: 60% !important;
                      border: none;
                      padding: 22px;
                      background: black;
                      color: white;
                    "
                  >
                    Invoice
                  </th>
                  <th
                    style="
                      width: 40% !important;
                      border: none;
                      padding: 22px;
                      background: #ddd;
                      text-align: center;
                      color: black;
                    "
                  >
                    Amount Due
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    style="
                      width: 60% !important;
                      padding-left: 20px;
                      background: black;
                      color: white;
                      padding-bottom: 20px;
                    "
                  >
                    On-Chip
                  </td>
                  <td
                    style="
                      width: 40% !important;
                      background: #ddd;
                      color: black;
                    "
                  >
                    <p v-if="invoice.status == 'pending'" class="text-center">
                      {{ appSettings.appSettings.currency_symbol }}{{ invoice.amount }}
                    </p>
                    <p v-else class="text-center">0</p>
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table_w" cellpadding="0" cellspacing="0">
              <thead>
                <tr>
                  <th
                    style="width: 50% !important; border: none; padding: 22px"
                  >
                    Bill To : <br />
                    <span style="font-weight: normal; font-size: 14px"
                      >{{ invoiceCompany.company_name }} ({{
                        invoiceCompany.comapny_number
                      }})</span
                    >
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    style="
                      width: 50% !important;
                      padding-left: 20px;
                      padding-bottom: 20px;
                    "
                  >
                    <!-- ​<span>burhan rao </span> -->
                    <br />{{ invoiceCompany.address }}<br /><br />
                    {{ invoiceCompany.company_phone }}<br />
                    {{ invoiceCompany.company_email }}
                  </td>
                  <td
                    style="
                      width: 30% !important;
                      text-align: center;
                      position: absolute;
                      right: 0px;
                      top: 136px;
                    "
                  >
                    Invoice Number: {{ invoiceDisplayNumber }} <br />
                    Invoice Dat​e: {{ invoice.invoice_date }}
                    <!-- <br />
                    Payment Due: November 16, 2021
                    <br />
                    <span>Amount Due (USD): $0.00​</span> -->
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="row">
              <div
                class="
                  col-12
                  table-border_
                  table-responsive
                  custom-scrollbar
                  table-view-responsive
                "
              >
                <table class="table mb-0">
                  <tr>
                    <th
                      scope="col"
                      style="color: var(--side-bar-dark-text-color)"
                    >
                      Items
                    </th>
                    <th
                      scope="col"
                      style="color: var(--side-bar-dark-text-color)"
                    >
                      Column Quantity
                    </th>
                    <th
                      scope="col"
                      style="color: var(--side-bar-dark-text-color)"
                    >
                      Price
                    </th>
                    <th
                      scope="col"
                      style="color: var(--side-bar-dark-text-color)"
                    >
                      Amount
                    </th>
                  </tr>
                  <tr>
                    <td style="color: black !important">
                      {{ invoiceItemTitle }}
                    </td>
                    <td style="color: black !important">1</td>
                    <td style="color: black !important">
                      {{ appSettings.appSettings.currency_symbol }}{{ invoice.amount }}
                    </td>
                    <td style="color: black !important">
                      {{ appSettings.appSettings.currency_symbol }}{{ invoice.amount }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <div style="margin-top: 20px; margin-bottom: 20px">
              <hr style="color: #ddd" />
            </div>

            <div
              style="
                width: 100%;
                text-align: end !important;
                position: relative;
                right: 0px;
              "
              class="block_right"
            >
              <div style="margin-right: 10%">
                Total:
                <span
                  style="
                    font-weight: normal;
                    font-size: 14px;
                    margin-left: 20px;
                  "
                >
                  {{ appSettings.appSettings.currency_symbol }}{{ invoice.amount }}</span
                >
              </div>
              <!-- <div
                style="
                  margin-top: 10px;
                  margin-right: 10%;
                  border-top: 1px solid #ddd;
                  border-bottom: 1px solid #ddd;
                  display: inline-block;
                  padding-top: 10px;
                  padding-bottom: 10px;
                "
              >
                Amount Du​e (USD):
                <span style="font-weight: bold; font-size: 14px; margin-left: 20px">
                  $0.00</span
                >
              </div> -->
            </div>

            <div>
              <p>
                <span style="font-weight: bold">Banking Detail:</span><br />
                <span v-html="appSettings.appSettings.banking_detail"></span>
              </p>
            </div>
            <div>
              <p>
                <span style="font-weight: bold">Note:</span><br />
                <span v-html="appSettings.appSettings.invoice_note"></span>
              </p>
            </div>
            <div style="margin-top: 20px; margin-bottom: 20px">
              <hr style="color: #ddd" />
            </div>
          </div>
        </div>
      </section>
    </VueHtml2pdf>

    <div class="text-right">
      <button @click="generateReport" class="btn btn-primary">Download</button>
    </div>
  </div>
</template>
<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin";
import { PERSONAL_INVOICE_SHOW } from "../../../../../Config/ApiUrl";
import AppLibrary from "../../../../../Helpers/AppLibrary";
import { axiosGet } from "../../../../../Helpers/AxiosHelper";
// import VueHtml2pdf from "vue-html2pdf";
export default {
  name: "InvoiceView",
  extends: AppLibrary,
  mixins: [FormMixin],
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      invoice: {
        company: {},
        package: {},
      },
    };
  },
  // components: {
  //   VueHtml2pdf,
  // },
  computed: {
    appSettings(){
      return this.$store.state.settings;
    },
    invoiceCompany() {
      return this.invoice?.company || {};
    },
    invoiceDisplayNumber() {
      return this.invoice?.invoice_number || "Pending";
    },
    invoiceItemTitle() {
      if (this.invoice?.package?.title) {
        return this.invoice.package.title;
      }

      if (this.invoice?.note) {
        return this.invoice.note;
      }

      return "Invoice Item";
    }
  },
  methods: {
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    getInvoice() {
      const invoiceId = this.id || this.getInvoiceIdFromLocation();

      if (!invoiceId) {
        return;
      }

      axiosGet(PERSONAL_INVOICE_SHOW + "/" + invoiceId)
        .then((res) => {
          this.invoice = this.normalizeInvoice(res.data);
          
        })
        .catch((error) => {
          
        });
    },
    getInvoiceIdFromLocation() {
      const myLocation = location.href;
      const split = myLocation.split("/");
      const lastSegment = split[7];

      return lastSegment ? Number(lastSegment.split("?")[0]) : 0;
    },
    normalizeInvoice(invoice) {
      return {
        ...invoice,
        company: invoice?.company || {},
        package: invoice?.package || {},
        note: invoice?.note || "",
        invoice_number: invoice?.invoice_number || "",
        invoice_date: invoice?.invoice_date || "",
        amount: invoice?.amount || 0,
        status: invoice?.status || "pending",
      };
    },
  },
  mounted() {
    this.getInvoice();
    // this.generateReport();
  },
  watch: {
    id() {
      this.getInvoice();
    },
  },
};
</script>
